/**
 * @name ie-versions.constants
 * @description Core ie versions constants in ngx-responsive
 *
 * @license MIT
 */
import { IIEVersions } from '../interfaces';

export const IE_VERSIONS: IIEVersions = {
    IE_7: 'ie 7',
    IE_8: 'ie 8',
    IE_9: 'ie 9',
    IE_10: 'ie 10',
    IE_11: 'ie 11',
    IE_12: 'ie +12'
};
